import { render } from "./defaultComponent.vue?vue&type=template&id=512477bf"
import script from "./defaultComponent.vue?vue&type=script&lang=js"
export * from "./defaultComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__